import { FC } from "react";
import { Modal } from "@mui/material";
import { BREAKPOINTS } from "../constants/common";
import { translation as t } from "../utils/translation";
import { ReactComponent as X } from "../assets/icons/x.svg";
import { useWindowSize } from "../hooks/useWindowWidth";
interface ErrorModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}
const ErrorModal: FC<ErrorModalProps> = ({ open, setOpen }) => {
  const windowWidth = useWindowSize();
  const { SMALL } = BREAKPOINTS;
  return (
    <Modal
      className="flex justify-center items-center text-darkBlue xs:text-[10px] xxl:text-[20px]"
      BackdropProps={{ style: { backgroundColor: "white", opacity: 0.8 } }}
      open={open}
      aria-labelledby="simple-modal-title"
    >
      <div className="bg-white flex flex-col items-center shadow-m xs:w-[90%] xxl:max-w-[800px] xxl:min-w-[600px] xs:py-10 xs:px-5 xxl:p-20  text-center">
        <X
          className={`stroke-red ${
            windowWidth > SMALL ? "w-[50px] h-[50px]" : "w-[30px] h-[30px]"
          }`}
        />
        <div className="flex flex-col items-center py-[20px]">
          <span
            id="modal-title"
            className="font-bold xxl:text-[40px] xs:text-[20px] "
          >
            <h2>{t.SERVICE_ERROR}</h2>
          </span>
          <span>{t.TRY_AGAIN_LAYTER}</span>
        </div>
        <div className="pt-5">
          <button
            className="flex bg-darkBlue text-white font-bold xs:w-40  xxl:w-60 h-14 p-2 rounded-m justify-center items-center disabled:bg-disabledGrey"
            type="submit"
            onClick={() => setOpen(false)}
          >
            {t.UNDERSTAND}
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default ErrorModal;